export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SitePagination.vue?vue&type=template&id=149941dd&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SitePagination.vue?vue&type=template&id=149941dd&scoped=true&
// module id = 236
// module chunks = 0